"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
function HeaderSelectionCell(props) {
    var defaultRendering = [
        (React.createElement("input", { key: 0, checked: props.selectionValue, id: props.inputId, type: "checkbox", className: "k-checkbox", onChange: function (e) {
                return props.selectionChange({
                    field: props.field,
                    syntheticEvent: e
                });
            } })),
        (React.createElement("label", { key: 1, className: "k-checkbox-label", htmlFor: props.inputId }))
    ];
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
}
exports.HeaderSelectionCell = HeaderSelectionCell;
//# sourceMappingURL=HeaderSelectionCell.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/header/HeaderSelectionCell.js
// module id = 6499
// module chunks = 0